/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.donations.config.settings.controllers', [
  'ui.router',
  'acme.common.service.api',
  'acme.common.service.helpers',
  'acme.common.service.permissions',
  'acme.common.factory.notice',
  'acme.common.factory.gridState',
  'acme.common.factory.gridDefinition',
  'acme.common.service.userPreferences'
])

.controller('DonationsConfigSettingsController', [
  '$scope', '$state', '$timeout', 'ApiService', 'HelpersService', 'NoticeFactory', 'PermissionsService', 'GridStateFactory', 'GridDefinitionFactory',
  function($scope, $state, $timeout, ApiService, HelpersService, NoticeFactory, PermissionsService, GridStateFactory, GridDefinitionFactory) {

    $scope.donationsConfigSettings = {

      model: {
        aspect: 'extendedForm',
        description: '',
        online: false,
        pos: false,
        csr: false
      },

      hasSettings: false,

      notice: new NoticeFactory(),
      gridState: new GridStateFactory(),
      gridDefinition: new GridDefinitionFactory(),

      init: function() {

        $scope.$emit('Application::contentTitleChange', {
          title: 'Config',
          buttonRight: {
            permissions: 'DONATIONS_CONFIG_UPDATE',
            label: 'Update settings ',
            opensDialog: true,
            action: function() {
              $scope.donationsConfigSettings.update();
            }
          }
        });

        this.getFormSettings();

      },

      getFormSettings: function() {
        var self = $scope.donationsConfigSettings;
        ApiService.donations.configs.list(self.gridState.getGridState()).then(self.success.getFormSettingsList, self.error.getFormSettingsList);
      },

      update: function() {
        var self = $scope.donationsConfigSettings,
            type = (this.hasSettings) ? 'update' : 'create';

        this.notice.hideSuccessMessages();
        this.notice.hideErrorMessages();
        ApiService.donations.configs[type](self.model).then(self.success.update, self.error.update);
      },

      success: {
        init: function(response) {},
        getFormSettingsList: function(response){
          var self = $scope.donationsConfigSettings;
          if(response.data.payload.list.length) {
            self.hasSettings = true;
            self.model = response.data.payload.list[0];
          }
        },
        update: function(response) {
          var self = $scope.donationsConfigSettings;
          self.notice.showSuccessMessages([{
            message: 'Successfully updated settings'
          }]);
          $timeout(function() {
            self.notice.hideSuccessMessages();
          }, 3000);
        }
      },

      error: {
        init: function(response) {},
        getFormSettingsList: function(response){},
        update: function() {}
      }

    };

    $scope.donationsConfigSettings.init();

}]);
